import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  const [token, setToken] = useState(localStorage.getItem("vox_token") || null);

  useEffect(() => {
    let active = true;
    const t = localStorage.getItem("vox_token");
    if (!t) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => { if (active) { localStorage.removeItem("vox_token"); setUser(false); } });
    return () => { active = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vox_token", data.access_token);
      setToken(data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("vox_token");
    setToken(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
